import { call, put, takeLatest } from 'redux-saga/effects'

import {
    NotificationCenterAction,
    NotificationCenterActionCategory,
    NotificationCenterCategory,
} from '../../@paco/entities/NotificationCenter/NotificationCenter'
import {
    endEventLoggerApiCall,
    startEventLoggerApiCall,
} from '../../@paco/entities/NotificationCenter/NotificationCenterService'

import {
    cancelShiftOffer,
    offerShift,
    registerShiftOffer,
    unregisterShiftOffer,
} from '../../helpers/api/shiftsApi'
import { getShiftById } from '../../helpers/api-ts/shiftsApi'
import { translate } from '../../helpers/translations/translator'
import {
    SET_LOADING,
    SHIFT_FAILURE,
    SHIFT_REQUEST,
    SHIFT_SAGA_CANCEL_OFFER_SHIFT,
    SHIFT_SAGA_GET_SHIFT,
    SHIFT_SAGA_OFFER_SHIFT,
    SHIFT_SAGA_REGISTER_OFFERED_SHIFT,
    SHIFT_SAGA_REGISTER_SHIFT,
    SHIFT_SAGA_SET_SHIFT,
    SHIFT_SAGA_UNREGISTER_OFFERED_SHIFT,
    SHIFT_SAGA_UNREGISTER_SHIFT,
    SHIFT_SUCCESS,
} from '../actionTypes'
import { deleteRegisteredShift, postRegisterShift } from '../shift-ts/shiftSaga'

function* fetchShift(action) {
    yield put({ type: SET_LOADING, loading: true })
    yield put({ type: SHIFT_REQUEST })
    try {
        const includes = [
            'department',
            'department.group',
            'tracks',
            'plannedUsers',
            'shiftPlannings',
            'shiftPlannings.comments',
            'shiftPlannings.user',
            'shiftPlannings.comments.owner',
        ]

        const response = yield call(() => getShiftById(includes, action.shiftUuid))
        const shift = yield call(() => response.data)

        yield put({
            type: SHIFT_SUCCESS,
            shift,
        })
    } catch (error) {
        yield put({ type: SHIFT_FAILURE, errors: [error.response] })
    }
    yield put({ type: SET_LOADING, loading: false })
}

function* postOfferShift(action) {
    yield put({ type: SET_LOADING, loading: true })

    const responseTracker = yield startEventLoggerApiCall(
        NotificationCenterCategory.EXCHANGE,
        NotificationCenterAction.CREATED,
        [NotificationCenterActionCategory.EXCHANGE_CREATED],
    )

    try {
        const exchangesLink = `/${translate('nav.exchanges.link')}`

        yield call(() => offerShift(action.shiftId, responseTracker.data))

        if (action.history) {
            action.history.push(exchangesLink)
        }
    } catch (error) {
        yield put({ type: SHIFT_FAILURE, errors: [error.response] })
        yield put({ type: SET_LOADING, loading: false })
    } finally {
        yield endEventLoggerApiCall(responseTracker.data)
    }
}

function* deleteOfferShift(action) {
    yield put({ type: SET_LOADING, loading: true })

    const responseTracker = yield startEventLoggerApiCall(
        NotificationCenterCategory.EXCHANGE,
        NotificationCenterAction.DELETED,
        [NotificationCenterActionCategory.EXCHANGE_CANCELLED],
    )

    try {
        const exchangesLink = `/${translate('nav.exchanges.link')}`

        yield call(() => cancelShiftOffer(action.shift, responseTracker.data))

        if (action.history) {
            action.history.push(exchangesLink)
        }
    } catch (error) {
        yield put({ type: SHIFT_FAILURE, errors: [error.response] })
        yield put({ type: SET_LOADING, loading: false })
    } finally {
        yield endEventLoggerApiCall(responseTracker.data)
    }
}

function* registerOfferedShift(action) {
    yield put({ type: SET_LOADING, loading: true })

    const responseTracker = yield startEventLoggerApiCall(
        NotificationCenterCategory.EXCHANGE,
        NotificationCenterAction.UPDATED,
        [NotificationCenterActionCategory.EXCHANGE_UPDATED],
    )

    try {
        const exchangesLink = `/${translate('nav.exchanges.link')}`

        yield call(() => registerShiftOffer(action.exchange, responseTracker.data))

        if (action.history) {
            action.history.push(exchangesLink)
        }
    } catch (error) {
        yield put({ type: SHIFT_FAILURE, errors: [error.response] })
        yield put({ type: SET_LOADING, loading: false })
    } finally {
        yield endEventLoggerApiCall(responseTracker.data)
    }
}

function* unregisterOfferedShift(action) {
    yield put({ type: SET_LOADING, loading: true })

    const responseTracker = yield startEventLoggerApiCall(
        NotificationCenterCategory.EXCHANGE,
        NotificationCenterAction.UPDATED,
        [NotificationCenterActionCategory.EXCHANGE_UPDATED],
    )

    try {
        const exchangesLink = `/${translate('nav.exchanges.link')}`

        yield call(() => unregisterShiftOffer(action.exchange, responseTracker.data))

        if (action.history) {
            action.history.push(exchangesLink)
        }
    } catch (error) {
        yield put({ type: SHIFT_FAILURE, errors: [error.response] })
        yield put({ type: SET_LOADING, loading: false })
    } finally {
        yield endEventLoggerApiCall(responseTracker.data)
    }
}

function* setShift(action) {
    yield put({
        type: SHIFT_SUCCESS,
        shift: action.shift,
    })
}

export default function* shiftsWatcher() {
    yield takeLatest(SHIFT_SAGA_GET_SHIFT, fetchShift)
    yield takeLatest(SHIFT_SAGA_REGISTER_SHIFT, postRegisterShift)
    yield takeLatest(SHIFT_SAGA_UNREGISTER_SHIFT, deleteRegisteredShift)
    yield takeLatest(SHIFT_SAGA_OFFER_SHIFT, postOfferShift)
    yield takeLatest(SHIFT_SAGA_CANCEL_OFFER_SHIFT, deleteOfferShift)
    yield takeLatest(SHIFT_SAGA_REGISTER_OFFERED_SHIFT, registerOfferedShift)
    yield takeLatest(SHIFT_SAGA_UNREGISTER_OFFERED_SHIFT, unregisterOfferedShift)
    yield takeLatest(SHIFT_SAGA_SET_SHIFT, setShift)
}
